<div class="tabs-container main-tabs-container">
  <div class="left-links" [ngClass]="{'collapsed-left-menu': !isMenuExpanded}">
    <mat-icon (click)="$event.stopPropagation();toggleLeftMenu()" class="left-menu-toggle">{{isMenuExpanded ?
      'chevron_left' : 'chevron_right' }}</mat-icon>
    <nav mat-tab-nav-bar color="primary" [tabPanel]="tabPanel" class="flex-row">
      @for (link of navLinks; track link; let i = $index) {
      @if (!link.subMenu) {
      <ng-container>
        <div class="displayBlock" [ngClass]="{'footer-expanded': isMenuExpanded}">
          @if (currentSelectedLinkIndex==link.index) {
          <mat-icon (click)="$event.stopPropagation();showTour(link.index)"
            (keydown.enter)="$event.stopPropagation();showTour(link.index)"
            (keydown.space)="$event.preventDefault();$event.stopPropagation();showTour(link.index)"
            class="help_menu" tabindex="0" role="button"
            [attr.aria-label]="link.helpText ? 'Help: ' + link.helpText : 'Help for ' + link.label"
            [matTooltip]="link.helpText" [matTooltipDisabled]="!link.helpText"
            matTooltipPosition="right">help</mat-icon>
          }
          @if (link.hasPermission) {
          <a mat-tab-link [attr.href]="null"
            [routerLink]="(link.isLegacy || link.isExternalRedirect) ? null : link.link"
            (click)="navigateToPage(link, $event)" tourAnchor="{{link.tourAnchor || ''}}" routerLinkActive
            #rla="routerLinkActive" [active]="rla.isActive" title="{{link.label}}">
            @if (!link.isNotRegularIcon) {
            <mat-icon>{{link.icon}}</mat-icon>
            } @else if(link.isNotRegularIcon) {
            <i class="{{link.icon}} icon-big"></i>
            }
            @if (isMenuExpanded) {
            <span title="{{link.label}}">{{link.label}}</span>
            }
          </a>
          }
        </div>
      </ng-container>
      } @else {
      @if (hasPermissionForSubMenu(link)) {
      <ng-container>
        <div class="displayBlock" [ngClass]="{'footer-expanded': isMenuExpanded}">
          <div>
            <a mat-tab-link (click)="toggleTree(link)">
              <mat-icon title="{{link.label}}">{{link.icon}}</mat-icon>
              @if (isMenuExpanded) {
              <span>{{link.label}}</span>
              }
              <mat-icon class="mat-icon-rtl-mirror" title="{{link.label}}">
                {{link.isExpanded ? 'expand_less' : 'expand_more'}}
              </mat-icon>
            </a>
            @if (link.isExpanded) {
            <div>
              @for (item of link.subMenu; track item) {
              @if (item.hasPermission) {
              @if(item.subMenu) {
              <a mat-tab-link class="custom-label sub-menu" [ngClass]="{'sub-menu-expanded': isMenuExpanded}"
                (click)="toggleTree(item)">
                <mat-icon title="{{item.label}}">{{item.icon}}</mat-icon>
                @if (isMenuExpanded) {
                <span>{{item.label}}</span>
                }
                <mat-icon class="mat-icon-rtl-mirror" title="{{item.label}}">
                  {{item.isExpanded ? 'expand_less' : 'expand_more'}}
                </mat-icon>
              </a>
              } @else {
              <a mat-tab-link title="{{item.label}}" [ngClass]="{'sub-menu-expanded': isMenuExpanded}"
                class="custom-label sub-menu"
                [attr.href]="null"
                [routerLink]="!item.isLegacy ? (item?.link || '') : null" (click)="navigateToPage(item, $event)"
                routerLinkActive #srla="routerLinkActive" [active]="srla.isActive">
                @if (!item.isNotRegularIcon) {
                <mat-icon>{{item.icon}}</mat-icon>
                } @else {
                <i class="{{item.icon}} sub-menu-icon"></i>
                }
                @if (isMenuExpanded) {
                <span>{{item.label}}</span>
                }
                @if(item.subMenu) {
                <mat-icon class="mat-icon-rtl-mirror" title="{{item.label}}">
                  {{item.isExpanded ? 'expand_less' : 'expand_more'}}
                </mat-icon>
                }
              </a>
              }
              @if (item.isExpanded) {
              <div>
                @for (subitem of item.subMenu; track subitem) {
                  @if (subitem.hasPermission) {
                <a mat-tab-link title="{{subitem.label}}"
                  [ngClass]="{'sub-menu-expanded child-menu-expanded': isMenuExpanded}" class="custom-label sub-menu"
                  [attr.href]="null"
                  [routerLink]="!subitem.isLegacy ? (subitem?.link || '') : null" (click)="navigateToPage(subitem, $event)"
                  routerLinkActive #srla="routerLinkActive" [active]="srla.isActive">
                  @if (!subitem.isNotRegularIcon) {
                  <mat-icon>{{subitem.icon}}</mat-icon>
                  } @else {
                  <i class="{{subitem.icon}} sub-menu-icon"></i>
                  }
                  @if (isMenuExpanded) {
                  <span>{{subitem.label}}</span>
                  }
                  @if(subitem.subMenu) {
                  <mat-icon class="mat-icon-rtl-mirror" title="{{subitem.label}}">
                    {{subitem.isExpanded ? 'expand_less' : 'expand_more'}}
                  </mat-icon>
                  }
                </a>
              }
                }
              </div>
              }
              }
              }
            </div>
            }
          </div>
        </div>
      </ng-container>
      }
      }
      }
    </nav>
   
    <div class="left-footer"  [ngClass]="{'footer-expanded': isMenuExpanded}">
      <div class="footer-content">
        @if (isMenuExpanded) {
        <img src="./assets/images/exostarlogo/GetLogo.png" alt="exostar-logo" class="footer-logo" />
        <span class="application-title">{{appName}} v{{appVersion}}</span>
        } @else{
        <span class="application-title" title="{{appName}} v{{appVersion}}">{{getAppInitials(appName)}}
          v{{appVersion}}</span>
        }
      </div>
    </div>

  </div>
  <mat-tab-nav-panel #tabPanel>
    <app-breadcrumbs></app-breadcrumbs>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>

</div>